import React from "react";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getIcon } from "../../../helpers/index";
import * as btnConfig from "../btnsSetup";

const RoundedButton = ({
  className = "",
  type = "button",
  rounded = false,
  disable = false,
  onClick = () => {},
  text = null,
  icon = null,
  faIcon = null,
  faIconR = null,
  btnType = null,
  size = "medium",
  alt = null,
  title = null,
  style = {},
  id = null,
  sx = {},
  testId = null,
}) => {
  // Ícones formatados
  const _icon = getIcon(icon);
  const _faIcon = faIcon ? <FontAwesomeIcon icon={faIcon} /> : null;
  const _faIconR = faIconR ? <FontAwesomeIcon icon={faIconR} /> : null;

  // Classes dinâmicas
  const btnTypeClass = btnConfig.getBtnTypeClass(btnType);
  const btnSizeClass = btnConfig.getBtnSize(size);

  //Estilizações para cada tipo de botão
  const borderRadius = rounded ? "50%" : size === "small" ? "16px" : "20px";
  const padding =
    size === "small" ? "6px 12px" : size === "large" ? "12px 24px" : "8px 16px";
  const minWidth =
    size === "small" ? "48px" : size === "large" ? "120px" : "auto";

  return (
    <Button
      variant="contained"
      type={type}
      disabled={disable}
      onClick={onClick}
      id={id}
      className={`${btnTypeClass} ${btnSizeClass} ${className}`}
      title={title || text}
      data-testid={testId}
      sx={{
        borderRadius: borderRadius,
        gap: "6px",
        minWidth: minWidth,
        padding: padding,
        fontWeight: "700",
        fontSize: "1rem",
        textTransform: "uppercase",
        border: "1px solid #FFCA55",
        background: "#FFCA55",
        color: "#662D91",
        ...style,
        ...sx,
      }}
    >
      {_faIcon} {text} {_icon} {_faIconR}
    </Button>
  );
};

export default RoundedButton;
